import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { MasterService } from '../../master/services/master.service';
import { bankAccountOptions, EntityFormOption } from '../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class FinancingFormLookupsFacade {

  constructor(private masterService: MasterService) { }

  bankAccounts(): Promise<EntityFormOption[]> {
    return firstValueFrom(this.masterService.getBankAccounts()).then(list => bankAccountOptions(list));
  }

  partners(): Promise<EntityFormOption[]> {
    return firstValueFrom(this.masterService.getParnerts()).then(list => (list || [])
      .filter(partner => partner && partner.id !== null && partner.id !== undefined)
      .map(partner => ({ id: partner.id, display: partner.display || '' })));
  }
}
